import { commonTexts, errorCodesEnglish, mapErrorCodeToUiMessage } from 'noddi-util';
import { NoddiButton } from '../../../Inputs/NoddiButton';
import { NoddiInfoBanner } from '../../NoddiInfoBanner';
import type { ApiErrorMessageProps } from '../types';

export function ApiErrorMessage({ error, errorCodes, onRetry, isRetrying, translations }: ApiErrorMessageProps) {
  const { tryAgain } = translations ?? commonTexts.errors;

  return (
    <div className='mt-2'>
      <NoddiInfoBanner
        variant='error'
        texts={[
          {
            value: mapErrorCodeToUiMessage({
              error,
              errorCodes: errorCodes ?? errorCodesEnglish
            })
          }
        ]}
        actionNode={
          onRetry && (
            <NoddiButton variant='outline' size='small' loading={isRetrying} onClick={onRetry}>
              {tryAgain}
            </NoddiButton>
          )
        }
      />
    </div>
  );
}

interface ErrorMessageProps {
  message: string;
}

export function ErrorMessage({ message }: ErrorMessageProps) {
  return (
    <div className='mt-2'>
      <NoddiInfoBanner variant='error' texts={[{ value: message }]} />
    </div>
  );
}
